import React from 'react';
import './stickerlabel.css'

const Stickerlabel = (props) => {
  return ( 
    <div className={props.labelstyle}>{props.labeltext}</div>
   );
}
 
export default Stickerlabel;
